<template>
  <b-modal
    id="observation-details-modal"
    ref="observationDetailsModal"
    size="xl"
    hide-header-close
    no-stacking
    centered
    scrollable
    @show="syncCurrentObservation"
  >
    <template #modal-header>
      <div class="btn-group ml-auto">
        <b-button
          size="sm"
          variant="outline-dark"
          title="View Observation Details in a New Tab"
          class="mr-1 px-4"
          @click="toObservationPage()">
          <i class="fa fa-eye"></i>
          <span class="HideResponsive">View (new tab) <i class="fas fa-external-link-alt fa-xs"></i></span>
        </b-button>
        <b-button
          v-if="canEdit"
          size="sm"
          variant="warning"
          title="Edit Observation Details in a New Tab"
          class="mr-1 px-4"
          @click="toEditPage()">
          <i class="fa fa-pencil"></i>
          <span class="HideResponsive">Edit <i class="fas fa-external-link-alt fa-xs"></i></span>
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          title="Previous Observation"
          @click="onPrevClick()"
          :disabled="currentIndex <= 0"
          class="px-4"
        ><i class="fa-solid fa-backward"></i>
          <span class="ml-1 HideResponsive">Prev</span>
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          title="Next Observation"
          @click="onNextClick()"
          :disabled="currentIndex >= arrObservationId.length - 1"
          class="px-4"
        ><i class="fa-solid fa-forward"></i>
          <span class="ml-1 HideResponsive">Next</span>
        </b-button>
        <b-button
          size="sm"
          variant="tertiary"
          title="Close"
          @click="resetModal()"
          class="px-4"
        ><i class="fa-solid fa-x"></i>
          <span class="ml-1 HideResponsive">Close</span>
        </b-button>
      </div>
    </template>
    <div class="card-body p-0 m-0">
      <ObservationView
        v-if="internalCurrentId"
        :key="internalCurrentId"
        :observation-id="internalCurrentId"
      ></ObservationView>
    </div>
    <template #modal-footer>
      <div class="btn-group ml-auto">
        <b-button
          size="sm"
          variant="outline-dark"
          title="View Observation Details in a New Tab"
          class="mr-1 px-4"
          @click="toObservationPage()">
          <i class="fa fa-eye"></i>
          <span class="HideResponsive">View (new tab) <i class="fas fa-external-link-alt fa-xs"></i></span>
        </b-button>
        <b-button
          v-if="canEdit"
          size="sm"
          variant="warning"
          title="Edit Observation Details in a New Tab"
          class="mr-1 px-4"
          @click="toEditPage()">
          <i class="fa fa-pencil"></i>
          <span class="HideResponsive">Edit <i class="fas fa-external-link-alt fa-xs"></i></span>
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          title="Previous Observation"
          @click="onPrevClick()"
          :disabled="currentIndex <= 0"
          class="px-4"
        ><i class="fa-solid fa-backward"></i>
          <span class="ml-1 HideResponsive">Prev</span>
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          title="Next Observation"
          @click="onNextClick()"
          :disabled="currentIndex >= arrObservationId.length - 1"
          class="px-4"
        ><i class="fa-solid fa-forward"></i>
          <span class="ml-1 HideResponsive">Next</span>
        </b-button>
        <b-button
          size="sm"
          variant="tertiary"
          title="Close"
          @click="resetModal()"
          class="px-4"
        ><i class="fa-solid fa-x"></i>
          <span class="ml-1 HideResponsive">Close</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import VueLoader from "../../../layout/Loader.vue";
import ObservationView from "../../../observation/view/index.vue"

export default {
  components: {
    VueLoader,
    ObservationView,
  },

  props: {
    arrObservationId: {
      type: Array,
      required: true,
    },
    currentObservationId: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      internalCurrentId: this.currentObservationId || null,
    };
  },

  watch: {
    currentObservationId(newId, oldVal) {
      this.internalCurrentId = newId || null;
    }
  },

  computed: {
    ...mapGetters({
      isManager: "project/get/isManager",
      observationVuex: "observation/view/observation",
      observationIsLoading: "observation/view/isLoading",
    }),
    observation() {
      if(this.observationIsLoading) {
        return null;
      }
      if(this.observationVuex && this.observationVuex.id != this.currentObservationId) {
        return null;
      }
      return this.observationVuex;
    },
    currentIndex() {
      return this.arrObservationId.indexOf(this.internalCurrentId);
    },
    canEdit() {
      if(this.isManager) {
        return true;
      }
      if(this.observation && this.isObserver(this.observation) && this.isProjectRoleMember(this.observation.project.id)) {
        return true;
      }

      return false;
    },
    canDelete() {
      if(this.isManager) {
        return true;
      }
      if(this.observation && this.isObserver(this.observation)) {
        return true;
      }
      return false;
    }
  },

  methods: {
    ...mapActions({
      resetObservation: "observation/view/reset",
    }),
    syncCurrentObservation() {
      this.internalCurrentId = this.currentObservationId || null;
    },
    toObservationPage() {
      let {href} = this.$router.resolve({name: 'ObservationShow', params: {id: this.internalCurrentId}});
      window.open(href, '_blank', 'noopener,noreferrer');
    },
    toEditPage() {
      let {href} = this.$router.resolve({name: 'ObservationEdit', params: {id: this.internalCurrentId}});
      window.open(href, '_blank', 'noopener,noreferrer');
    },
    onPrevClick() {
      if (this.currentIndex > 0) {
        this.internalCurrentId = this.arrObservationId[this.currentIndex - 1];
      }
    },
    onNextClick() {
      if (this.currentIndex < this.arrObservationId.length - 1) {
        this.internalCurrentId = this.arrObservationId[this.currentIndex + 1];
      }
    },
    resetModal() {
      this.internalCurrentId = null;
      this.resetObservation();
      this.$bvModal.hide("observation-details-modal");
    },
  },
};
</script>

<style scoped lang="scss">
</style>

<!--<style>-->
<!--  dialog-class="wider-modal"-->
<!--@media (min-width: 1200px) {-->
<!--  .wider-modal {-->
<!--    max-width: 70% !important; /* Or use a hard width like 1400px */-->
<!--  }-->
<!--}-->
<!--</style>-->
